import React from 'react';

export const TagCheckIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/tag/checked' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <path
          d='M11.5000006,5.00000064 C12.0281463,4.99957981 12.5350183,5.20808036 12.9100013,5.58000127 L12.9100013,5.58000127 L19.4031564,12.0737268 C18.7942766,12.3838174 18.2380669,12.7824939 17.7515071,13.2527769 L11.5000013,7.00000127 L4.50000126,7.00000127 L4.50000126,14.0000013 L13.5000013,23.0000013 L16.0558381,20.4454083 C16.29078,21.1098016 16.6255591,21.7270207 17.0421476,22.279038 L14.9100013,24.4100013 C14.536651,24.7855891 14.0295781,24.9977685 13.5000006,25.0000006 C12.9718562,25.0004227 12.4649842,24.7919222 12.0900013,24.4200013 L12.0900013,24.4200013 L3.09000126,15.4200013 C2.71196186,15.0442049 2.49957888,14.5330459 2.50000063,14.0000006 L2.50000063,14.0000006 L2.50000063,7.00000064 C2.50000063,5.89543177 3.39543176,5.00000064 4.50000063,5.00000064 L4.50000063,5.00000064 Z M7.00000126,8.00000127 C7.82842838,8.00000127 8.50000126,8.67157415 8.50000126,9.50000127 C8.50000126,10.3284284 7.82842838,11.0000013 7.00000126,11.0000013 C6.17157413,11.0000013 5.50000126,10.3284284 5.50000126,9.50000127 C5.50000126,8.67157415 6.17157413,8.00000127 7.00000126,8.00000127 Z'
          id='Combined-Shape'
          fill='currentColor'
          fillRule='nonzero'
        ></path>
        <polygon
          id='Path-Copy-4'
          fill='#5EB523'
          points='17.7987757 19.4953037 19.2544055 18.037615 20.5782668 19.3635353 25.7337082 14.2163294 27.1862497 15.6750476 20.5782668 22.2737654'
        ></polygon>
      </g>
    </svg>
  );
};
